import { createContext } from 'react'
import { ICmsContentContext } from './types'

const CmsContentContext = createContext<ICmsContentContext>({})

export { CmsContentContext }
